import {createFileRoute} from '@tanstack/react-router'
import LeagueLiveView from '../../leagues/LeagueLiveView'
import services from '../../services'
import {config} from '../../config/config'
import {LeagueType} from '../../constants'
import {humanizeSlug} from '../../utilities'

export const Route = createFileRoute('/live/leagues/$league_uid')({
    component: RouteComponent,
    // Fetch the league server-side so the title/description below render in the SSR HTML (SEO),
    // not just after the client-side query resolves. Public endpoint — no auth needed.
    loader: async ({params}) => {
        try {
            const league = await services.leagues.find(params.league_uid)
            return {event: league && (league as any).uid ? league : null}
        } catch {
            return {event: null}
        }
    },
    head: ({loaderData, params}) => {
        const e: any = (loaderData as any)?.event
        const name = e?.title || humanizeSlug(params.league_uid)
        const label = e?.type === LeagueType.Ladder ? 'Ladder' : 'League'
        const sport = e?.sport_type ? String(e.sport_type).replace(/_/g, ' ') : 'sports'
        const slug = e?.slug || params.league_uid
        return {
            meta: [
                {title: `${name} | Live ${label} | ScorePal`},
                {name: 'description', content: `Follow ${name} live on ScorePal. Real-time ${sport} ${label.toLowerCase()} standings, fixtures, results, and player stats.`},
            ],
            links: [{rel: 'canonical', href: `${config.publicUrl}/live/leagues/${slug}/`}],
        }
    },
})

function RouteComponent() {
    return <LeagueLiveView />
}
